import * as React from 'react'

import { inject, observer } from 'mobx-react'

import Localization from '../../localization/LocalizationManager'
import User from '../../models/User'
import ProjectMembersStore from '../../stores/domain/ProjectMembers.store'
import InitialState from '../../stores/InitialState'
import BaseCompactPopup from '../BaseCompactPopup/BaseCompactPopup'
import CompactUserProfile from '../CompactUserProfile/CompactUserProfile'
import { PanelSections } from '../PanelSections/PanelSections'

interface IProps {
  userId: string

  projectMembersStore?: ProjectMembersStore
  state?: InitialState
}

@inject('projectMembersStore', 'state')
@observer
export default class GlobalUserCard extends React.Component<IProps> {
  public render() {
    const { userId, state } = this.props

    const user = this.props.projectMembersStore.getById(userId)

    return user ? (
      <BaseCompactPopup
        isShown={true}
        onHide={state.resetIdOfUserDisplayedOnGlobalCard}
        childrenClassName="tw:flex tw:flex-col tw:flex-1 tw:min-h-0"
      >
        <PanelSections.Header
          title={Localization.translator.userDetails}
          onClose={state.resetIdOfUserDisplayedOnGlobalCard}
        />
        <PanelSections.Content>
          <CompactUserProfile
            user={user.asJson as User}
            allUsers={[]}
            isPreviewMode={true}
          />
        </PanelSections.Content>
      </BaseCompactPopup>
    ) : null
  }
}
